import axios from "axios";
import { useCallback, useState } from "react";

const usePaginatedData = ({ apiUrl, initialParams = {}, method = "post" }) => {
  const [records, setRecords] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    skip: 0,
    limit: 10,
    totalPages: 0,
  });

  const fetchData = useCallback(
    async (overrideParams = {}) => {
      try {
        const payload = {
          skip: pagination.skip,
          limit: pagination.limit,
          ...initialParams,
          ...overrideParams,
        };
        const res = await axios[method.toLowerCase()](apiUrl, payload);
        // await axios.post(apiUrl, payload);
        setRecords(res.data.rows || res.data);
        setTotalCount(res.data.count || res.data.length);
        setPagination((prev) => ({
          ...prev,
          totalPages: Math.ceil(
            (res.data.count || res.data.length) / prev.limit,
          ),
        }));
      } catch (err) {
        console.error(err);
        alert("Error loading data");
      }
    },
    [apiUrl, pagination.skip, pagination.limit, initialParams],
  );
  return {
    records,
    totalCount,
    pagination,
    setPagination,
    fetchData,
  };
};

export default usePaginatedData;
